<div class="content racers-page">
    <h1>
        <span>Racer Management</span>
    <!--<p>Load a table of all racers with basic information on page load, allowing the ability to click through to a form displaying all of the users information.</p>-->

        <span class="row" style="display:inline; margin-left: 20px;" *ngIf="dataService.appMode == 'manager'">
            <button class="btn btn-primary" (click)="addRacer()" style="margin-right:10px;" *ngIf="mode == 'browse'">Add a New Racer</button>
            <button class="btn btn-primary" (click)="browseRacers()" style="margin-left:10px;" *ngIf="mode != 'browse'">Browse All Racers</button>
        </span>
    </h1>
    <div class="row">
        <span style="cursor:pointer" (click)="viewAllRacers = !viewAllRacers">View
            <span *ngIf="viewAllRacers">only <strong>2023</strong> Backyard Racers</span> 
            <span *ngIf="!viewAllRacers">Backyard Racers from <strong>ALL</strong> Years.</span> 
        </span>
    </div>
    <hr />
    <!-- BROWSE MODE -->
    <div *ngIf="mode == 'browse'" class="browse-racers">
        <!--<span>TODO: Add Sorting</span>-->
        <table class="table table-striped racer-table">
            <thead>
                <tr>
                    <th scope="col">Bib#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Location</th>
                    <th scope="col">Photo</th>
                    <th scope="col">Division</th>
                    <th scope="col" *ngIf="dataService.appMode =='manager'">Checked In</th>
                    <th scope="col" *ngIf="dataService.appMode =='manager'">Laps</th>
                </tr>
            </thead>
            <tbody *ngIf="!viewAllRacers">
                <tr *ngFor="let racer of dataService.currentYearBackyardRacers" class="racer-row">
                    <td (click)="editRacerFormBuild(racer)">
                        <span class="bib-icon y2023">
                            <span *ngIf="racer.backyard2023.bibNumber != ''">{{racer.backyard2023.bibNumber}}</span>
                            <span *ngIf="racer.backyard2023.bibNumber == ''">-</span>
                        </span>
                    </td>
                    <td (click)="editRacerFormBuild(racer)">{{racer.firstName}} {{racer.lastName}}</td>
                    <td (click)="editRacerFormBuild(racer)">{{racer.city}}, {{racer.state}}</td>
                    <td (click)="editRacerFormBuild(racer)" style="padding-top:2px; padding-bottom:2px;">
                        <span *ngIf="racer.profileImageUrl">
                            <img src="{{racer.profileImageUrl}}" class="racer-image" />
                        </span>
                        <span *ngIf="!racer.profileImageUrl">
                            <img src="{{helperService.defaultProfileImageUrl}}" class="racer-image" />
                        </span>
                    </td>
                    <td (click)="editRacerFormBuild(racer)">{{helperService.racerDivision(racer)}}</td>
                    <td *ngIf="dataService.appMode =='manager'">
                        <input type="checkbox" [ngModel]="racer.checkedIn" (click)="checkInRacer(racer)" />
                    </td>
                    <td *ngIf="dataService.appMode =='manager'" style="font-size:.8em;">
                        <span *ngIf="racer.laps.length > 0">{{racer.laps.length}} Laps Present</span><br />
                        <button class="btn btn-outline-primary btn-sm" *ngIf="racer.laps.length > 0" (click)="archiveLaps(racer)">Move to 2022</button>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="viewAllRacers">
                <tr *ngFor="let racer of dataService.racers" class="racer-row">
                    <td (click)="editRacerFormBuild(racer)">
                        <span *ngIf="racer.backyard2023">
                            <span class="bib-icon">{{racer.backyard2023.bibNumber}}</span><br />
                        </span>
                        <span *ngIf="racer.backyard2022 && !racer.backyard2023">
                            <span class="bib-icon">{{racer.backyard2022.bibNumber}}</span><br />
                        </span>
                        <span *ngIf="racer.backyard2021 && !racer.backyard2022 && !racer.backyard2023">
                            <span class="bib-icon">{{racer.backyard2021.bibNumber}}</span><br />
                        </span>
                        <span *ngIf="racer.backyard2022">
                            <span *ngIf="racer.backyard2022.bibNumber > 0" class="small" style="padding:0 2px">2022</span>
                        </span>
                        <span *ngIf="racer.backyard2021">
                            <span *ngIf="racer.backyard2021.bibNumber > 0" class="small" style="padding:0 2px">2021</span>
                        </span>
                    </td>
                    <td (click)="editRacerFormBuild(racer)">{{racer.firstName}} {{racer.lastName}}</td>
                    <td (click)="editRacerFormBuild(racer)">{{racer.city}}, {{racer.state}}</td>
                    <td (click)="editRacerFormBuild(racer)" style="padding-top:2px; padding-bottom:2px;">
                        <span *ngIf="racer.profileImageUrl">
                            <img src="{{racer.profileImageUrl}}" class="racer-image" />
                        </span>
                        <span *ngIf="!racer.profileImageUrl">
                            <img src="{{helperService.defaultProfileImageUrl}}" class="racer-image" />
                        </span>
                    </td>
                    <td (click)="editRacerFormBuild(racer)">{{helperService.racerDivision(racer)}}</td>
                    <td *ngIf="dataService.appMode =='manager'">
                        <input type="checkbox" [ngModel]="racer.checkedIn" (click)="checkInRacer(racer)" />
                    </td>
                    <td *ngIf="dataService.appMode =='manager'" style="font-size:.8em;">
                        <span *ngIf="racer.laps.length > 0">{{racer.laps.length}} Laps Present</span><br />
                        <button class="btn btn-outline-primary btn-sm" *ngIf="racer.laps.length > 0" (click)="archiveLaps(racer)">Move to 2022</button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!--BUILDING-->
        <!--<form>-->
            <!--Full text search: <input class="form-control ml-2" type="text" name="searchTerm" [(ngModel)]="service.searchTerm"/>-->
            <!--<span class="ml-3" *ngIf="service.loading$ | async">Loading...</span>-->
        <!--</form>-->

        <!--<table class="table table-striped">-->
            <!--<thead>-->
            <!--<tr>-->
                <!--<th scope="col" sortable="bib" (sort)="onSort($event)">Bib</th>-->
                <!--<th scope="col" sortable="firstName" (sort)="onSort($event)">First Name</th>-->
                <!--<th scope="col" sortable="lastName" (sort)="onSort($event)">Last Name</th>-->
                <!--<th scope="col" sortable="location" (sort)="onSort($event)">Location</th>-->
                <!--&lt;!&ndash;<th scope="col" sortable="race" (sort)="onSort($event)">Race</th>&ndash;&gt;-->
            <!--</tr>-->
            <!--</thead>-->
            <!--<tbody>-->
            <!--<tr *ngFor="let racer of racers | async; index as i">-->
                <!--<td><ngb-highlight [result]="racer.bib" [term]="filter.value"></ngb-highlight></td>-->
                <!--<td><ngb-highlight [result]="racer.firstName" [term]="filter.value"></ngb-highlight></td>-->
                <!--<td><ngb-highlight [result]="racer.lastName" [term]="filter.value"></ngb-highlight></td>-->
                <!--<td><ngb-highlight [result]="racer.city" [term]="filter.value"></ngb-highlight></td>-->
                <!--&lt;!&ndash;<td><ngb-highlight [result]="country.population | number" [term]="filter.value"></ngb-highlight></td>&ndash;&gt;-->
            <!--</tr>-->
            <!--</tbody>-->
        <!--</table>-->

    </div>

    <!-- EDIT & CREATE MODE -->
    <div *ngIf="mode == 'edit' || mode == 'create'">
        <form [formGroup]="racerForm">
            <div class="row col-12 form-group">
                <div class="col-4">
                    <label>First Name</label>
                    <input type="text" formControlName="firstName" class="form-control" />
                </div>
                <div class="col-4">
                    <label>Last Name</label>
                    <input type="text" formControlName="lastName" class="form-control" />
                </div>
                <div class="col-4">
                    <label>Gender</label>
                    <select class="form-control" formControlName="gender">
                        <option *ngFor="let option of genderOptions" [ngValue]="option.value">{{option.label}}</option>
                    </select>
                </div>
            </div>
            <div class="row col-12 form-group">
                <div class="col-4">
                    <label>Email</label>
                    <input type="email" formControlName="email" class="form-control" />
                </div>
                <div class="col-4">
                    <label>Phone</label>
                    <input type="text" formControlName="mainPhone" class="form-control" />
                </div>
                <div class="col-4">
                    <label>Year of Birth</label>
                    <select formControlName="yob" class="form-control">
                        <option *ngFor="let year of yobOptions" [ngValue]="year">{{year}}</option>
                    </select>
                </div>
            </div>
            <div class="row col-12 form-group" style="padding-left:20px;">
                <label>Address</label>
                <input type="text" formControlName="streetAddress" class="form-control col-12" />
            </div>
            <div class="row col-12 form-group">
                <div class="col-3">
                    <label>City</label>
                    <input type="text" formControlName="city" class="form-control" />
                </div>
                <div class="col-3">
                    <label>State</label>
                    <input type="text" formControlName="state" class="form-control" />
                </div>
                <div class="col-3">
                    <label>Zip</label>
                    <input type="text" formControlName="zip" class="form-control" />
                </div>
                <div class="col-3">
                    <label>Country</label>
                    <input type="text" formControlName="country" class="form-control" />
                </div>
            </div>
            <div class="row col-12">
                <div class="col-2">
                    <span *ngIf="racerForm.value.profileImageUrl">
                        <img src="{{racerForm.value.profileImageUrl}}" alt="Racer Profile Image" />
                    </span>
                </div>
                <div class="col-10">
                    <label>Profile Image URL: </label>
                    <input type="text" formControlName="profileImageUrl" class="form-control" />
                </div>
            </div>
            <hr />
            <div class="row col-12">
                <div class="col-4">
                    <label>Alt. Contact Name</label>
                    <input type="text" formControlName="alternativeContactName" class="form-control" />
                </div>
                <div class="col-4">
                    <label>Alt. Contact Phone</label>
                    <input type="text" formControlName="alternativeContactPhone" class="form-control" />
                </div>
                <div class="col-4">
                    <label>Alt. Contact Email</label>
                    <input type="email" formControlName="alternativeContactEmail" class="form-control" />
                </div>
            </div>
            <hr />
            <div class="row col-12 race-selected text-center">
                <div class="col-4" formGroupName="backyard2023">
                    <label><input type="checkbox" formControlName="registered" class="form-control" />Backyard 2023</label>
                </div>
                <div class="col-6">
                    <strong>Former Races:</strong><br />
                    <ul style="text-align: left;">
                        <li *ngIf="racerForm.value.backyard2022.registered">
                            2022 Entrant
                            <span *ngIf="racerForm.value.backyard2022.bibNumber">({{racerForm.value.backyard2022.bibNumber}})</span> 
                            <span *ngIf="racerForm.value.backyard2022.laps"> Laps: {{racerForm.value.backyard2022.laps.length - 1}}</span>
                        </li>
                        <li *ngIf="racerForm.value.backyard2021.registered">
                            2021 Entrant
                            <span *ngIf="racerForm.value.backyard2021.bibNumber">({{racerForm.value.backyard2021.bibNumber}})</span>
                            <span *ngIf="racerForm.value.backyard2021.laps"> Laps: {{racerForm.value.backyard2021.laps.length - 1}}</span>
                        </li>
                    </ul>
                </div>
                
                <!-- <div class="col-4" formGroupName="doubleDown2023"> -->
                    <!-- <label><input type="checkbox" formControlName="registered" class="form-control" />Double Down 2022</label> -->
                <!-- </div> -->
                <div class="col-2"></div>
            </div>
            <div class="backyard-form" formGroupName="backyard2023" *ngIf="racerForm.value.backyard2023.registered">
                <div class="row col-12 form-group">
                    <div class="col-4">
                        <label>Bib Number</label><br />
                        <input type="number" formControlName="bibNumber" class="form-control" />
                    </div>
                    <div class="col-4">
                        <label>Confirmation Number</label>
                        <input type="number" formControlName="confirmationNo" class="form-control" />
                    </div>
                    <div class="col-4">
                        <label>Date Registered</label>
                        <input type="text" formControlName="registeredDate" class="form-control" />
                    </div>
                </div>
            </div>
            <!--
            <div class="doubledown-form" formGroupName="doubleDown2022" *ngIf="racerForm.value.doubleDown2022.registered">
                <div class="row col-12 form-group">
                    <div class="col-3">
                        <label>Bib Number</label>
                        <input type="number" formControlName="bibNumber" class="form-control" />
                    </div>
                    <div class="col-3">
                        <label>Division</label>
                        <input type="text" formControlName="division" class="form-control" />
                    </div>
                    <div class="col-3">
                        <label>Confirmation Number</label>
                        <input type="number" formControlName="confirmationNo" class="form-control" />
                    </div>
                    <div class="col-3">
                        <label>Date Registered</label>
                        <input type="text" formControlName="registeredDate" class="form-control" />
                    </div>
                </div>
            </div>
                -->
            <div class="actions col-12">
                <button class="btn btn-outline-primary" (click)="saveRacer()">
                    <span *ngIf="mode == 'create'">Create Racer</span>
                    <span *ngIf="mode == 'edit'">Update Racer</span>
                </button>
            </div>
        </form>
    </div>
</div>
